module.exports = __webpack_public_path__ + "static/media/pending.e91e17ff.svg";